module.exports = __webpack_public_path__ + "fb4fb547e429a96cb15a09d0b659a7e5.MP3";